<div class="scheduler-info">
  @if (!hasError) {
    @if (isPublishDate || isCloseDate) {
      <div
        [rtTooltip]="templateData.tooltipContent"
        [rtTooltipMaxWidth]="185"
        [rtTooltipHasTextAlignCenter]="true"
        layout-centered
      >
        <rt-icon name="alarm"></rt-icon>
        <span> {{ templateData.content }} </span>
      </div>
    }
  } @else {
    <rt-icon name="error-outline"></rt-icon>
    <rt-job-scheduler-error [schedulerError]="schedulerData?.error"></rt-job-scheduler-error>
  }
</div>
